__turbopack_context__.v({
  "container": "Sidebar-module-scss-module__hQabzG__container",
  "group": "Sidebar-module-scss-module__hQabzG__group",
  "group-links": "Sidebar-module-scss-module__hQabzG__group-links",
  "link": "Sidebar-module-scss-module__hQabzG__link",
});
